<template>
    <div class="section">
        <div class="container">
            <h2 class="col-12">Conheça os Treinamentos Hello<label>.</label></h2>

            <div class="row m-0">

                <div class="col-12 col-lg-3">
                    <div class="col-12 p-0 course-item">
                        <div class="col-12 p-0 course-image">
                            <img class="col-12 p-0" 
                                src="https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/deploy-ec2-course.webp"/>
                        </div>
                        <div class="col-12 course-description">
                            <h5 class="col-12 p-0">Deploy no AWS EC2 e CloudFlare</h5>
                            <div class="col-12 p-0">
                                <p>Aprenda a criar servidores em nuvem, realizar deploy de uma aplicação, 
                                    crie e restaure snapshots. Aprenda a calcular e reduzir custos e muito mais.
                                </p>                            
                            </div>
                        </div>                    
                        <div class="col-12 row m-0 course-actions">
                            <div class="col-8 p-0">
                                <n-button type="primary" 
                                    v-on:click="evtMoreDetails('deploy-on-aws-ec2-and-cloudflare')" round>
                                    Mais detalhes
                                    <i class="fas fa-arrow-right"></i>
                                </n-button>
                            </div>
                            <div class="col-4 p-0 text-right">
                                <n-button type="default" round icon
                                    v-on:click="evtShare">
                                    <i class="fas fa-share-alt"></i>
                                </n-button>
                            </div>
                        </div>
                    </div>
                </div>               
                

            </div>

        </div>
    </div>
</template>

<script>

import {
  Button
} from '@/components';

export default {
    name: 'hello-courses',
    components: {
        [Button.name]: Button
    },
    data() {
        return {
            courses: [
                {
                    id: 'deploy-on-aws-ec2-and-cloudflare',
                    header: 'https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/aws-cloudflare.webp',
                    name: 'Deploy no Amazon EC2 e CloudFlare.',
                    whoYouAre: 'Desenvolvedores e administradores de sistemas com conhecimento em deploy de aplicações, redes e gerenciamento de servidores.',
                    results: 'Aprenda a criar servidores em nuvem, realizar o deploy de uma aplicação asp net core, configurar sua VPC, crie e restaure snapshots, trabalhe com IPs elásticos. Aprenda a calcular e reduzir custos. Aponte DNS para o seu servidor pela CloudFlare.',
                    description: 'Realize o curso com carga horária de 24 horas com o professor Huander Tironi. As aulas são online em um período de 3 dias.',
                    professorName: 'Huander Tironi',
                    professorTitle: 'Mestre em Engenharia de Software',
                    professorCV: 'Huander atua há 10 anos na área de Tecnologia da Informação. Mestre pela PUC Curitiba na área de ciência da computação com ênfase em Engenharia de Software. Especialista em Cloud Computing, Desenvolvimento de Software. Cofundador da TARS Tecnologia. Professor de arquitetura de software e gestão de portfólios e projetos na PUC Paraná - Campus Londrina.',
                    professorGithub: 'https://github.com/huandertironi',
                    professorInstagram: 'https://www.instagram.com/coding_tironi/'
                }
            ]  
        }
    },
    methods: {
        evtMoreDetails: function (route) {

            this.$router.push(`/course/${route}`);

        },
        async evtShare() {

            let firstCourse = this.courses[0]

            const shareData = {
                title: firstCourse.name,
                text: 'Aprenda sobre Cloud Computing com a CloudCT!',
                url: `https://cloudct.com.br/course${firstCourse.id}`
            }

            try {
                await navigator.share(shareData)
            } catch (err) {
                console.error(err)
            }


        }
    }
}
</script>

<style scoped lang="scss">

.section {
    background-color: #ecf0f1;

    .course-item {
        position: relative;
        min-height: 440px;

        .course-image {
            min-height: 185px;
            background-color: #fff;
        }

        .course-description {            
            position: absolute;
            z-index: 200;
            background-color: #fff;
            bottom: 0;
            transition: bottom 0.5s;
            min-height: 255px;
        }

        .course-actions {
            position: absolute;
            bottom: 0;
            z-index: 100;
            background-color: #ddd;
        }
    }

    .course-item:hover > .course-description {
        bottom: 60px;
    }

    h1 {
        label {
            color: #4834d4;
        }
    }

    p {
        font-size: 1.1em;
    }
}

</style>
